import { widgetPropType } from 'constants';

import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@nextiva/next-ui-components';

import { withLicensePermissionsCheck } from '../../../enhancers';
import HeaderIcon from '../../HeaderIcon';

import './CommonButton.scss';

class CommonButton extends React.Component {
  static propTypes = {
    blockName: PropTypes.string,
    className: PropTypes.string,
    tooltipText: PropTypes.string.isRequired,
    icon: PropTypes.string,
    customIconClass: PropTypes.string,
    widget: widgetPropType,
  };

  static defaultProps = {
    blockName: 'nx-global-header-button',
  };

  state = {
    isPopoverOpen: false,
    isTooltipVisible: false,
    anchorEl: null,
  };

  setTooltipVisibility = (isTooltipVisible) => {
    this.setState({ ...this.state, isTooltipVisible: isTooltipVisible });
  };

  togglePopover = (e) => {
    const { isPopoverOpen } = this.state;

    this.setState({
      ...this.state,
      anchorEl: e.currentTarget,
      isPopoverOpen: !isPopoverOpen,
      isTooltipVisible: false,
    });
  };

  handleClick = (e) => {
    this.togglePopover(e);
    const { widget: { onClickHandler, linkProps: { onClick } = {} } = {} } = this.props;

    if (onClickHandler) {
      e.preventDefault();
      onClickHandler(e);
    }
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  render() {
    const { isTooltipVisible, isPopoverOpen, anchorEl } = this.state;
    const {
      blockName,
      className,
      widget: { popoverBody, iconBody, badge, link, linkProps },
      tooltipText,
      icon,
      customIconClass,
    } = this.props;

    if (iconBody) {
      return <HeaderIcon iconRenderer={iconBody} />;
    }

    return (
      <Tooltip
        title={tooltipText}
        open={isTooltipVisible}
        placement="bottom"
        id="m-global-header__tooltip"
        arrow
      >
        <a
          className={blockName}
          onClick={this.handleClick}
          aria-label={tooltipText}
          href={link || null}
          tabIndex={0}
          onMouseEnter={() => this.setTooltipVisibility(true)}
          onMouseLeave={() => this.setTooltipVisibility(false)}
          {...linkProps}
        >
          <HeaderIcon
            icon={icon}
            badge={badge}
            className={className}
            customIconClass={customIconClass}
            setTooltipVisibility={this.setTooltipVisibility}
            popoverBody={popoverBody && popoverBody()}
            isPopoverOpen={isPopoverOpen}
            togglePopover={this.togglePopover}
            anchorEl={anchorEl}
          />
        </a>
      </Tooltip>
    );
  }
}

export default withLicensePermissionsCheck(CommonButton);
